import { useState } from 'react';
import { Box, Grid, Paper, Typography } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { ProgressBarComponent, Button } from '@roc/ui';
import { LoanProcess } from '@roc/feature-utils';
import { TodoTaskCard } from '@roc/feature-loan-details';
import { AddDrawDocumentDialog } from '../common/addDrawDocumentDialog';
import AddIcon from '@material-ui/icons/Add';
import { useDocumentStore } from '@roc/feature-documents';
import {
  SOW_REVISION_STAGE,
  ON_HOLD,
  INSURANCE_DRAW,
} from '../constants/draws';
import { useDrawsStore } from '../hooks';
import { Alert, AlertTitle } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import { DrawTodos } from './drawTodos';
import { DrawActionButtons } from 'libs/feature-loan-details/src/loanDetails/components/action-buttons/drawActionButtons';
import { useUserStore, useBaseStore } from '@roc/feature-app-core';
import { SELF_INSPECTION_MOBILE } from '../stores/drawActionsStore';
import { MobileSnapDrawAlert } from './mobileSnapDrawAlert';
import { MorganStanleyAlert } from './morganStanleyAlert';

const useStyles = makeStyles(theme => ({
  stepper: {
    border: 'solid 1px rgba(225, 225, 225, 1)',
    borderRadius: 8,
    overflow: 'auto',
    '& .MuiStepConnector-lineHorizontal': {
      marginTop: 3,
      borderTopWidth: 4,
      backgroundColor: 'rgba(255, 255, 255, 1)',
    },
    '& .MuiStepIcon-root': {
      fontSize: 35,
    },
  },
  button: {
    border: `1px solid rgba(40, 83, 145, 1)`,
    borderRadius: 4,
    backgroundColor: 'transparent',
    fontSize: 14,
    fontWeight: 500,
    color: 'rgba(40, 83, 145, 1)',
    padding: '4px 8px',
    marginLeft: 10,
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: 'rgba(237, 237, 237, 1)',
    },
  },
  buttonModal: {
    display: 'flex',
    marginLeft: 'auto',
    marginBottom: 16,
  },
}));
export const DrawDetailsModalShared = observer(
  ({
    loanId,
    drawId,
    isCPortal,
  }: {
    loanId: string;
    drawId: string;
    isCPortal?: boolean;
  }) => {
    const classes = useStyles();
    const [isUploadDialogOpen, setIsUploadDialogOpen] = useState(false);
    const { drawStore } = useDrawsStore();
    const { documentStore } = useDocumentStore();
    const { userStore } = useUserStore();
    const { globalStore } = useBaseStore();
    const [investor, setInvestor] = useState();

    useEffect(() => {
      setInvestor(documentStore?.loanStore?.loanDetails?.investorName);
      drawStore.fetchDrawDTOById(drawId);
      return () => {
        drawStore.resetCurrentDraw();
        documentStore.resetDrawDocuments();
        documentStore.resetDrawComments();
      };
    }, []);

    useEffect(() => {
      if (drawStore.currentDraw) {
        drawStore.drawFormStore.onFieldChange(
          'drawId',
          drawStore.currentDraw.drawId
        );
        drawStore.drawFormStore.onFieldChange(
          'propertyId',
          drawStore.currentDraw.propertyId
        );
      }
    }, [drawStore.currentDraw]);

    if (!drawStore.currentDraw || !documentStore.drawDocuments) {
      return <></>;
    }

    const displayProgressBar =
      drawStore.currentDraw.stage !== SOW_REVISION_STAGE &&
      drawStore.currentDraw.stage !== INSURANCE_DRAW &&
      drawStore.currentDraw.stage !== ON_HOLD &&
      drawStore.currentDraw.stageArray?.length > 0;

    const borrowers = documentStore?.loanStore?.loanDetails?.borrowers ?? [];
    const isSnapDrawEligible = borrowers.every(
      b => b?.isEligibleForSnapDraws === true
    );
    const isDiscountedDraw = borrowers.some(b => b?.isDiscountedDraw === true);
    const isMobileDraw =
      drawStore.currentDraw.inspectionCompany === SELF_INSPECTION_MOBILE;

    return (
      <Grid container spacing={2}>
        {isDiscountedDraw && globalStore.isInternalPortal && (
          <Grid item xs={12}>
            <Alert severity="error">
              <AlertTitle>
                <strong>Discounted draw</strong>
              </AlertTitle>
              This borrower is eligible for the discounted draw category. Please ensure the fees are changed accordingly as per the new guidelines.
            </Alert>
          </Grid>
        )}
        {!isSnapDrawEligible && (
          <Grid item xs={12}>
            <Alert severity="warning">
              <AlertTitle>
                <strong>Snap Draws Disabled</strong>
              </AlertTitle>
              At least one borrower on this loan is not eligible for Snap Draws.
            </Alert>
          </Grid>
        )}
        {drawStore.currentDraw.stage === ON_HOLD && (
          <Grid item xs={12}>
            <Alert severity="warning">Draw Request is currently On Hold</Alert>
          </Grid>
        )}
        {displayProgressBar && (
          <Grid item xs={12}>
            <Box className={classes.stepper}>
              <ProgressBarComponent
                progressArray={drawStore.currentDraw.stageArray}
                active={drawStore.currentDraw.stage}
              />
            </Box>
          </Grid>
        )}
        {(
          <Grid item xs={12}>
            <MobileSnapDrawAlert
              isMobileDraw={isMobileDraw}
              investor={investor}
              lenderId={documentStore?.loanStore?.loanDetails?.lenderId}
            />
          </Grid>
        )}
        {userStore.isNportalUser && (
          <Grid item xs={12}>
            <DrawActionButtons loanId={+loanId} drawId={+drawId} />
          </Grid>
        )}
        <Grid item xs={12}>
          <DrawTodos isCPortal={isCPortal} loanId={+loanId} drawId={+drawId} />
        </Grid>
        <Grid item xs={12}>
          <Box style={{ height: '30px' }} />
        </Grid>
      </Grid>
    );
  }
);

export default DrawDetailsModalShared;
